<template>
  <div class="task stavke-lista">

    <v-card outlined>
      <v-card-title class="naslov-kartice">
        {{documentNameLoc}} — stavke
        <span class="znak">{{ items.length }} {{ mnozinaStavke }} · {{ localMoney(zbrojUkupno) }}{{ haveCurrency }}</span>
        <v-spacer></v-spacer>
        <span class="znak sitno">klik na redak otvara stavku</span>
      </v-card-title>

      <div class="alatke-stavke">
        <v-btn small :outlined="!viseStupaca" :color="viseStupaca ? 'primary' : 'primary'" :dark="viseStupaca" @click="viseStupaca = !viseStupaca">
          {{ viseStupaca ? 'Manje stupaca' : 'Više stupaca' }}
        </v-btn>
        <v-btn small outlined color="primary" @click="itemcard">{{lang.ItemCard}}</v-btn>
        <v-btn small outlined color="primary" @click="profitcard">{{lang.ProfitCard}}</v-btn>
        <v-btn small outlined color="primary" @click="suppliercard">{{lang.SuppCard}}</v-btn>
        <v-spacer></v-spacer>
        <!-- Traziti ima smisla tek na duzoj listi; 96 % dokumenata ima do 10 stavaka. -->
        <div style="max-width:260px" v-if="items.length > 10">
          <v-text-field
            append-icon="mdi-magnify"
            label="Traži"
            single-line
            hide-details
            dense
            outlined
            v-model="search"
          ></v-text-field>
        </div>
        <span v-if="!locked">
          <v-btn fab small dark class="indigo" @click='documentnew' title="Nova stavka">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </span>
      </div>

      <v-data-table
          dense
          :headers="headers"
          :items="items"
          :search="search"
          :custom-filter="filtrirajSve"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50]
          }"
          :items-per-page="20"
          item-key="id"
          @click:row="navigateTo"
          :mobile-breakpoint="0"
        >
        <template v-slot:[`item.redniBroj`]="{ index }">
          <span class="grey--text">{{ index + 1 }}</span>
        </template>

        <template v-slot:[`item.slika`]="{ item }">
          <img
            v-if="slikePrikaz[item.id]"
            :src="slikePrikaz[item.id]"
            class="slicica"
            alt=""
            @click.stop="prikaziSliku(item)"
          >
          <span v-if="!slikePrikaz[item.id]" class="bez-slike">—</span>
        </template>

        <!-- Sifra i opis idu ispod naziva, umjesto u vlastite stupce. -->
        <template v-slot:[`item.itemName`]="{ item }">
          <div class="naziv">{{ item.itemName }}</div>
          <div class="sitno">
            {{ item.itemID }}
            <v-icon x-small v-if="item.itemService" class="ml-1" title="Usluga">mdi-wrench</v-icon>
          </div>
          <div class="sitno" v-if="item.itemDescription">{{ item.itemDescription }}</div>
        </template>

        <template v-slot:[`item.kolicina`]="{ item }">
          <span>{{ localKolicina(item[poljeKolicina]) }}</span>
        </template>
        <template v-slot:[`item.cijena`]="{ item }">
          <span>{{ formatPrice3(item[poljeCijena]) }}</span>
        </template>
        <template v-slot:[`item.itemDiscountPercentage1`]="{ item }">
          <span v-if="pNum(item.itemDiscountPercentage1) !== 0">{{ localMoney(item.itemDiscountPercentage1) }} %</span>
          <span v-if="pNum(item.itemDiscountPercentage1) === 0" class="grey--text">—</span>
        </template>
        <template v-slot:[`item.iznos`]="{ item }">
          <span>{{ localMoney(item[poljeIznos]) }}</span>
        </template>
        <template v-slot:[`item.itemVAT1Percentage`]="{ item }">
          <span>{{ localMoney(item.itemVAT1Percentage) }} %</span>
        </template>
        <template v-slot:[`item.ukupno`]="{ item }">
          <span class="ukupno">{{ localMoney(item[poljeUkupno]) }}</span>
        </template>

        <template v-slot:[`item.itemSuppPrice`]="{ item }">
            <span v-if="side === 1">{{ localMoney(item.itemSuppPrice) }}</span>
        </template>
        <template v-slot:[`item.itemSuppPriceAmount`]="{ item }">
            <span v-if="side === 1">{{ localMoney(item.itemSuppPriceAmount) }}</span>
        </template>
        <template v-slot:[`item.itemMarginAmount`]="{ item }">
            <span v-if="side === 1">{{ localMoney(item.itemMarginAmount) }}</span>
        </template>
        <template v-slot:[`item.itemSuppBaseForePrice`]="{ item }">
            <span v-if="side === 1 && exportDoc">{{ localMoney(item.itemSuppBaseForePrice) }}</span>
        </template>
        <template v-slot:[`item.ItemExRate`]="{ item }">
            <span v-if="side === 1 && exportDoc">{{ formatPrice3(item.ItemExRate) }}</span>
        </template>
        <template v-slot:[`item.itemDependablesAmount`]="{ item }">
            <span v-if="side === 1 && exportDoc">{{ localMoney(item.itemDependablesAmount) }}</span>
        </template>
        <template v-slot:[`item.osnovica`]="{ item }">
            <span>{{ localMoney(item[poljeOsnovica]) }}</span>
        </template>
        <template v-slot:[`item.itemPriceWithVAT`]="{ item }">
            <span>{{ localMoney(item.itemPriceWithVAT) }}</span>
        </template>

        <!-- Zbroj na dnu tablice, da se ne mora gore u karticu. Celije se
             crtaju po stupcima, pa ostaju poravnate i kad se stupci mijenjaju. -->
        <template v-slot:[`body.append`]>
          <tr class="zbroj-red">
            <td v-for="stupac in headers" :key="stupac.value" class="text-right">
              <span v-if="stupac.value === 'iznos'">{{ localMoney(zbrojIznos) }}</span>
              <span v-if="stupac.value === 'osnovica'">{{ localMoney(zbrojOsnovica) }}</span>
              <!-- U stupcu "PDV %" retci pokazuju postotak, a zbroj je iznos
                   PDV-a. Bez oznake se cita kao zbroj postotaka. -->
              <span v-if="stupac.value === 'itemVAT1Percentage'"><span class="oznaka-zbroja">PDV</span> {{ localMoney(zbrojPdv) }}</span>
              <span v-if="stupac.value === 'ukupno'" class="ukupno">{{ localMoney(zbrojUkupno) }}</span>
            </td>
          </tr>
        </template>

        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          From {{ pageStart }} to {{ pageStop }}
        </template>
        <template v-slot:no-data>
          {{ lang.noData }}
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dijalogSlika" max-width="600px">
      <v-card>
        <v-card-title class="subtitle-1">{{ slikaNaziv }}</v-card-title>
        <v-card-text class="text-center">
          <img :src="slikaVelika" style="max-width:100%;max-height:70vh" alt="">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dijalogSlika = false">{{langC.Close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.profcard">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <DocumentItemsProfitCard />
              </v-col>
            </v-row>
        </div>
        <div v-if="this.itemCard">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <DocumentItemCard />
              </v-col>
            </v-row>
        </div>
        <div v-if="this.suppcard">
            <v-row class="pt-2">
                <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                  <DocumentItemCardBySupp />
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import DocumentItemsProfitCard from './DocumentItemsProfitCard'
import DocumentItemCard from './DocumentItemCard'
import DocumentItemCardBySupp from './DocumentItemCardBySupp'
import moneyFormat, { kolicinaFormat } from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import { dohvatiSliku } from '../Item/slikaArtikla'

export default {
  name: 'documentdetaillist',
  data () {
    return {
      documentNameLoc: '',
      lang: {},
      langC: {},
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: '',
        databaseDocID: 0
      },
      haveCurrency: '',
      profcard: false,
      suppcard: false,
      exportDoc: false,
      side: 1,
      locked: false,
      documentAna: {},
      itemCard: false,
      viseStupaca: false,
      dijalogSlika: false,
      slikaVelika: '',
      slikaNaziv: '',
      slikePrikaz: {}
    }
  },
  components: {
    DocumentItemsProfitCard,
    DocumentItemCard,
    DocumentItemCardBySupp
  },
  mounted () {
      if (this.$store.state.documentActivHead && this.$store.state.documentActivHead.documentLocked === true) {
        this.locked = true
      }
      this.side = this.$store.state.documentSide
      this.documentNameLoc = this.$store.state.documentActivLoc
      if (this.$store.state.language === 'EN') {
        this.lang = langEn
        this.langC = commEn
      }
      if (this.$store.state.language === 'HR') {
        this.lang = langHr
        this.langC = commHr
      }
      this.exportDoc = this.$store.state.documentActivHead.exportDoc
      this.items = this.$store.state.documentActivItems ? this.$store.state.documentActivItems : []
      if (this.exportDoc === false) {
        this.haveCurrency = this.$store.state.documentActivHead.documentHomeCurrency ? (' ' + this.$store.state.documentActivHead.documentHomeCurrency) : ''
      } else {
        this.haveCurrency = this.$store.state.documentActivHead.documentForeignCurrency ? (' ' + this.$store.state.documentActivHead.documentForeignCurrency) : ''
      }
      this.ucitajSlike()
      // Stupci se vise ne slazu ovdje, u sest zakucanih varijanti. Gradi ih
      // izracunato svojstvo "headers", prema strani dokumenta, valuti i tome
      // ima li koja stavka rabat ili sliku.
  },
  methods: {
    pNum (vrijednost) {
      return parseFloat(vrijednost) || 0
    },
    zbroji (polje) {
      return this.items.reduce((zbroj, stavka) => zbroj + this.pNum(stavka[polje]), 0)
    },
    // Slika se na stavku prepisuje iz sifrarnika kad se stavka doda, pa je
    // ovdje nema potrebe dohvacati. Ide ona koja je u sifrarniku oznacena kao
    // zadana; stare stavke nemaju tu oznaku, pa im se uzima prva popunjena.
    slikaStavke (stavka) {
      if (!stavka) { return '' }
      const zadana = parseInt(stavka.ItemDefaultPicture, 10)
      if (zadana >= 1 && zadana <= 7) {
        const put = stavka['ItemPicture' + zadana]
        if (put && String(put).trim().length > 0) { return String(put).trim() }
      }
      for (let i = 1; i <= 7; i++) {
        const put = stavka['ItemPicture' + i]
        if (put && String(put).trim().length > 0) { return String(put).trim() }
      }
      return ''
    },
    // Uploadana slika trazi prijavu, pa se ne moze staviti izravno u <img>;
    // dohvaca se s tokenom. Javni link prolazi kakav jest.
    async ucitajSlike () {
      const novi = {}
      for (const stavka of this.items) {
        const put = this.slikaStavke(stavka)
        if (put) {
          novi[stavka.id] = await dohvatiSliku(put, this.$store.state.companyid)
        }
      }
      this.slikePrikaz = novi
    },
    prikaziSliku (stavka) {
      this.slikaVelika = this.slikePrikaz[stavka.id] ? this.slikePrikaz[stavka.id] : this.slikaStavke(stavka)
      this.slikaNaziv = stavka.itemName ? stavka.itemName : ''
      this.dijalogSlika = true
    },
    // Zadano Vuetijevo trazenje gleda samo stupce koji su prikazani, pa se
    // sifra ili opis ne bi nasli. Ovo trazi po svim poljima stavke.
    filtrirajSve (vrijednost, trazi, stavka) {
      if (!trazi) { return true }
      const pojam = trazi.toString().toLowerCase()
      return Object.keys(stavka).some(kljuc => {
        const polje = stavka[kljuc]
        if (polje === null || polje === undefined || typeof polje === 'object') { return false }
        return String(polje).toLowerCase().indexOf(pojam) !== -1
      })
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    // Kolicina ide na 3 decimale kad ih ima (tonaza), inace na 2 kao i dosad.
    localKolicina(kolicina) {
      return kolicinaFormat(kolicina)
    },
    async itemcard() {
      if (!this.$store.state.itemActiv){
        alert('Error! Item is not selected. Greška! Nije odabran niti jedan artikal!')
        return
      }
      this.itemCard = false
      if (this.$store.state.companyid) {
        this.documentAna.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.documentAna.BusinessYear = this.$store.state.businessYear
      }
      this.documentAna.itemID = this.$store.state.itemActiv.itemID ? this.$store.state.itemActiv.itemID : null
      this.documentAna.docFromDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
      this.documentAna.docToDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
      this.documentAna.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid  : 1
      await this.$store.dispatch('setDocumentAna', this.documentAna)
      this.itemCard = true
    },
    formatPrice3 (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(3).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(3).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    profitcard() {
      this.profcard = !this.profcard
    },
    suppliercard() {
      this.suppcard = !this.suppcard
    },
    async navigateTo (item) {
      if (!this.locked) {
        this.$store.dispatch('seteditItem', 1)
        this.$store.dispatch('setnewItem', 0)
        this.$store.dispatch('setItemActiv', item)
        if (item.id) {
          this.$store.dispatch('setDocumentDetailid', item.id)
          await this.$router.push({
            name: 'documentdetailcreate2'
          })
        } else {
          confirm(this.lang.Error1)
        }
      }
    },
    async documentnew () {
      try {
        this.$store.dispatch('seteditItem', 0)
        this.$store.dispatch('setnewItem', 1)
        this.$store.dispatch('setDocumentDetailid', 0)
        this.$store.dispatch('setItemActiv', null)
        await this.$router.push({
          name: 'documentdetailcreate2'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {
    // Koje polje nosi kolicinu, cijenu i iznose ovisi o strani dokumenta i o
    // tome je li dokument u stranoj valuti. Prije je zbog toga bilo sest
    // gotovo istih popisa stupaca.
    poljeKolicina () {
      if (this.side === 1) { return 'itemPcsPlus' }
      if (this.side === 2) { return 'itemPcsMinus' }
      return 'itemPcsNeutral'
    },
    poljeCijena () { return this.exportDoc ? 'itemForePrice' : 'itemPrice' },
    poljeIznos () { return this.exportDoc ? 'itemBaseForeAmount' : 'itemBaseAmount' },
    poljeOsnovica () { return this.exportDoc ? 'itemBaseForeAmountNoVAT' : 'itemBaseAmountNoVAT' },
    poljeUkupno () { return this.exportDoc ? 'itemForeAmountWithVAT' : 'itemAmountWithVAT' },

    // Stupac se pokazuje samo kad ga barem jedna stavka doista koristi.
    prikaziRabat () {
      return this.items.some(stavka => this.pNum(stavka.itemDiscountPercentage1) !== 0)
    },
    prikaziSlike () {
      return this.items.some(stavka => this.slikaStavke(stavka) !== '')
    },
    // Nabavna cijena i marza imaju smisla samo na primci.
    prikaziNabavnu () {
      return this.viseStupaca && this.side === 1
    },

    headers () {
      const stupci = []
      stupci.push({ text: '#', value: 'redniBroj', sortable: false, filterable: false, width: '34px' })
      if (this.prikaziSlike) {
        stupci.push({ text: '', value: 'slika', sortable: false, filterable: false, width: '46px' })
      }
      stupci.push({ text: this.lang.ItemName, align: 'left', sortable: true, value: 'itemName', width: '320px' })
      stupci.push({ text: this.lang.ItemUnit, align: 'center', sortable: false, value: 'itemUnit', width: '60px' })
      stupci.push({ text: this.lang.ItemPcsNeutral, align: 'right', sortable: false, value: 'kolicina', width: '90px' })
      stupci.push({ text: this.lang.ItemPrice + this.haveCurrency, align: 'right', sortable: false, value: 'cijena', width: '110px' })
      if (this.prikaziRabat) {
        stupci.push({ text: this.lang.ItemDiscountPercentage1, align: 'right', sortable: false, value: 'itemDiscountPercentage1', width: '80px' })
      }
      stupci.push({ text: this.lang.ItemBaseAmount + this.haveCurrency, align: 'right', sortable: true, value: 'iznos', width: '120px' })
      if (this.prikaziNabavnu) {
        if (this.exportDoc) {
          stupci.push({ text: this.lang.itemSuppBaseForePrice + this.haveCurrency, align: 'right', sortable: false, value: 'itemSuppBaseForePrice', width: '110px' })
          stupci.push({ text: this.lang.ItemExRate, align: 'right', sortable: false, value: 'ItemExRate', width: '90px' })
          stupci.push({ text: this.lang.itemDependablesAmount, align: 'right', sortable: false, value: 'itemDependablesAmount', width: '110px' })
        }
        stupci.push({ text: this.lang.ItemSuppPrice, align: 'right', sortable: false, value: 'itemSuppPrice', width: '110px' })
        stupci.push({ text: this.lang.ItemSuppPriceAmount, align: 'right', sortable: false, value: 'itemSuppPriceAmount', width: '110px' })
        stupci.push({ text: this.lang.ItemMarginAmount, align: 'right', sortable: false, value: 'itemMarginAmount', width: '110px' })
      }
      if (this.viseStupaca) {
        stupci.push({ text: this.lang.ItemBaseAmountNoVAT + this.haveCurrency, align: 'right', sortable: false, value: 'osnovica', width: '120px' })
      }
      stupci.push({ text: this.lang.ItemVAT1Percentage, align: 'right', sortable: true, value: 'itemVAT1Percentage', width: '110px' })
      if (this.viseStupaca) {
        stupci.push({ text: this.lang.ItemPriceWithVAT + this.haveCurrency, align: 'right', sortable: false, value: 'itemPriceWithVAT', width: '120px' })
      }
      stupci.push({ text: this.lang.ItemAmountWithVAT + this.haveCurrency, align: 'right', sortable: true, value: 'ukupno', width: '130px' })
      if (this.viseStupaca) {
        stupci.push({ text: this.lang.id, value: 'id', sortable: false, width: '60px' })
      }
      return stupci
    },

    zbrojIznos () { return this.zbroji(this.poljeIznos) },
    zbrojOsnovica () { return this.zbroji(this.poljeOsnovica) },
    zbrojUkupno () { return this.zbroji(this.poljeUkupno) },
    zbrojPdv () { return this.zbrojUkupno - this.zbrojOsnovica },

    mnozinaStavke () {
      const n = this.items.length
      const zadnja = n % 10
      const zadnje2 = n % 100
      if (zadnja === 1 && zadnje2 !== 11) { return 'stavka' }
      if (zadnja >= 2 && zadnja <= 4 && (zadnje2 < 12 || zadnje2 > 14)) { return 'stavke' }
      return 'stavaka'
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Naslov je namjerno isti kao na ostalim karticama (forma.css), da stavke
   izgledaju kao dio istog dokumenta. */
.stavke-lista .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 14px;
  min-height: 0;
}
.stavke-lista .naslov-kartice .znak {
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 10px;
}
.stavke-lista .alatke-stavke {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.stavke-lista .naziv {
  font-weight: 500;
}
.stavke-lista .sitno {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}
.stavke-lista .ukupno {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.stavke-lista .slicica {
  width: 36px;
  height: 36px;
  object-fit: cover;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  cursor: zoom-in;
}
/* Postotak i iznos se ne prelamaju - "0,00 %" je inace znalo pasti u dva reda. */
.stavke-lista >>> td,
.stavke-lista >>> th {
  white-space: nowrap;
}
/* Naziv, sifra i opis se i dalje smiju prelomiti. */
.stavke-lista .naziv,
.stavke-lista .sitno {
  white-space: normal;
}
.stavke-lista .bez-slike {
  color: #cfd8dc;
}
.stavke-lista .oznaka-zbroja {
  font-size: 11px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  margin-right: 2px;
}
.stavke-lista .zbroj-red td {
  background: #f5f5f5;
  font-weight: 700;
  border-top: 2px solid rgba(0, 0, 0, 0.12);
}
</style>
